<template>
  <b-button
    :disabled="disabled"
    tag="router-link"
    :to="to"
    >
    <slot />
    {{name}}
  </b-button>
</template>

<script>
export default {
  name: 'ButtonLink',
  props: {
    name: {
      type: String,
      default: () => ''
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    to: {
      type: String,
      default: () => '#'
    }
  }
}
</script>

<style lang="sass">
</style>
